import { z } from 'zod'
import { sortOrderSchema } from '@/types/schema/antd/sort-order-schema'

export const sorterParamsSchema = z.object({
  sort_field: z.string().optional(),
  sort_by: sortOrderSchema.nullish(),
})

export type SorterParams = z.infer<typeof sorterParamsSchema>
